import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Constants from "../utils/Constants";
import { Tooltip } from "react-tooltip";
import dangerSign from '../assets/img/danger-sign.svg'
import { CALL_ACK_OPTIONS } from '../utils/CallAckMessages';

class CallNotification extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userName: "",
            ackSentByRoom: {},
            ackLoadingRoomId: null,
        }
    }

    handleAck = async (call, messageKey) => {
        const { onAcknowledge } = this.props;
        if (!onAcknowledge || !call?.roomId) {
            return;
        }
        this.setState({ ackLoadingRoomId: call.roomId });
        try {
            const ok = await onAcknowledge(call, messageKey);
            if (ok) {
                this.setState((prev) => ({
                    ackSentByRoom: {
                        ...prev.ackSentByRoom,
                        [call.roomId]: messageKey,
                    },
                }));
            }
        } finally {
            this.setState({ ackLoadingRoomId: null });
        }
    }

    render() {
        const { callDetails, joinNow, rejectNow, callMute, mute } = this.props;
        const { ackSentByRoom, ackLoadingRoomId } = this.state;
        return (
            <div className='call-notification'>
                {
                    callDetails?.map((o, index) => {
                        const sentKey = ackSentByRoom[o?.roomId];
                        return <React.Fragment key={o?.roomId || index}>
                            <div className='card call-card'>
                                <p className='user-call-name'>
                                    {o?.callPriority === 2 && <img className='emergency-call' src={dangerSign}></img>}
                                    <span className='name-high'>{o?.User?.fullName ? o?.User?.fullName : (o?.SrmIpRoomServiceMapping?.SrmIpRoom?.patientRoomName)}</span>
                                    {o?.callPriority !== 2 && <span className='d-none d-md-block'>{Constants.IS_CALLING}</span>}
                                </p>
                                <div className="call-ack-options" aria-label="Quick reply to patient">
                                    {CALL_ACK_OPTIONS.map((opt) => {
                                        const sent = sentKey === opt.key;
                                        return (
                                            <button
                                                key={opt.key}
                                                type="button"
                                                className={`call-ack-btn${sent ? ' sent' : ''}`}
                                                disabled={ackLoadingRoomId === o?.roomId}
                                                onClick={() => this.handleAck(o, opt.key)}
                                            >
                                                {sent ? `✓ ${opt.label}` : opt.label}
                                            </button>
                                        );
                                    })}
                                </div>
                                <div className="d-flex justify-content-center icons mt-3">
                                    <div className="cuatomer-call-circle-end mx-3 OnJoinIcon attenCallTooltip" onClick={() => joinNow(o)}>
                                        <i className="fa-solid fa-phone mic-icon-end"></i>
                                        <Tooltip anchorSelect=".attenCallTooltip" place="top">
                                            Attend Call
                                        </Tooltip>
                                    </div>
                                    <div className="cuatomer-call-circle-end red-end mx-3 OnRejectIcon rejectCallTooltip" onClick={() => rejectNow(o)}>
                                        <i className="fa-solid fa-phone call-icon-end" ></i>
                                        <Tooltip anchorSelect=".rejectCallTooltip" place="top">
                                            Reject Call
                                        </Tooltip>
                                    </div>
                                    {mute ? <div className="cuatomer-call-circle-end mx-3 OnRejectIcon mutedTooltip" onClick={() => callMute()}>
                                        <i className="fa-solid fa-volume-xmark mic-icon-end" ></i>
                                        <Tooltip anchorSelect=".mutedTooltip" place="top">
                                            Muted
                                        </Tooltip>
                                    </div> : <div className="cuatomer-call-circle-end mx-3 OnRejectIcon muteTooltip" onClick={() => callMute()}>
                                        <i className="fa-solid fa-volume-high mic-icon-end" ></i>
                                        <Tooltip anchorSelect=".muteTooltip" place="top">
                                            Mute
                                        </Tooltip>
                                    </div>}
                                </div>
                            </div>
                        </React.Fragment>
                    })
                }
            </div>
        )
    }
}
export default withRouter(CallNotification);
